// notifications.ts — fetch live notifications from the backend and remember
// which ones the user has dismissed. Fails soft: no backend (or offline) simply
// means no notification tiles, never an error.
import { BACKEND_URL } from '@/config/backend';
import { storage } from './storage';

export interface AppNotification {
  id: number;
  title: string;
  body: string;
  button: { label: string; url: string } | null;
  created_at: string;
}

const DISMISSED_KEY = 'renurture.notifications.dismissed.v1';

export async function fetchNotifications(): Promise<AppNotification[]> {
  if (!BACKEND_URL) return [];
  try {
    const res = await fetch(`${BACKEND_URL.replace(/\/$/, '')}/api/notifications`);
    if (!res.ok) return [];
    const data = (await res.json()) as { notifications?: AppNotification[] };
    return Array.isArray(data.notifications) ? data.notifications : [];
  } catch {
    return [];
  }
}

export function getDismissed(): number[] {
  const raw = storage.get(DISMISSED_KEY);
  if (!raw) return [];
  try {
    const arr = JSON.parse(raw);
    return Array.isArray(arr) ? arr.filter((n) => typeof n === 'number') : [];
  } catch {
    return [];
  }
}

export function dismissNotification(id: number): void {
  const next = Array.from(new Set([...getDismissed(), id]));
  storage.setJSON(DISMISSED_KEY, next);
}
